/**
 * Published Connector version for in-app update banner.
 * Primary source: MAESTRO_KV CONNECTOR_LATEST_TAG (Control Center pin).
 * Fallback: latest.json (Tauri updater manifest — may noop when auto-update kill switch is off).
 */
import { CLOUD_API_URL } from '../config/serverConfig';

function normalizeVersion(raw: unknown): string | null {
  const tag = String(raw ?? '').trim();
  if (!tag) return null;
  return tag.replace(/^v/i, '');
}

export async function fetchConnectorLatestPublishedVersion(): Promise<string | null> {
  try {
    const res = await fetch(
      `${CLOUD_API_URL}/api/config/connector-latest-tag?_=${Date.now()}`,
      { credentials: 'omit' },
    );
    if (res.ok) {
      const data = await res.json() as { tag?: string; version?: string };
      const fromKv = normalizeVersion(data?.tag ?? data?.version);
      if (fromKv) return fromKv;
    }
  } catch { /* KV endpoint optional until Mycelium deploy */ }

  try {
    const res = await fetch(
      `${CLOUD_API_URL}/api/maestro/updates/latest.json?_=${Date.now()}`,
      { credentials: 'omit' },
    );
    if (res.ok) {
      const data = await res.json() as { version?: string };
      return normalizeVersion(data?.version);
    }
  } catch { /* ignore */ }

  return null;
}
